export default __webpack_public_path__ + "assets/_Chapters/EPLSystem/br_ls_ms.webp";